/**
 * @flow
 * @relayHash dc7d721256d0f99d50c47dc328af771d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type NofollowedPagesTable_project$ref = any;
export type indexing_IndexingCategory_NofollowedPagesTable_QueryVariables = {|
  host: string
|};
export type indexing_IndexingCategory_NofollowedPagesTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: NofollowedPagesTable_project$ref
  |}
|};
export type indexing_IndexingCategory_NofollowedPagesTable_Query = {|
  variables: indexing_IndexingCategory_NofollowedPagesTable_QueryVariables,
  response: indexing_IndexingCategory_NofollowedPagesTable_QueryResponse,
|};
*/


/*
query indexing_IndexingCategory_NofollowedPagesTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...NofollowedPagesTable_project
    id
  }
}

fragment NofollowedPagesTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countNofollowTypesNofollowedPages(url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {
          type
          count
        }
        nofollowedPages(offset: 0, limit: 20, url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}, nofollowTypeFilters: []) {
          count
          edges {
            node {
              ...NofollowedPagesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment NofollowedPagesRow_issue on NofollowedPage {
  id
  type
  severity
  url
  source_url
  nofollow_types
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v4 = {
  "kind": "Literal",
  "name": "sourceUrl",
  "value": v3,
  "type": "TextFilters"
},
v5 = {
  "kind": "Literal",
  "name": "url",
  "value": v3,
  "type": "TextFilters"
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "indexing_IndexingCategory_NofollowedPagesTable_Query",
  "id": null,
  "text": "query indexing_IndexingCategory_NofollowedPagesTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...NofollowedPagesTable_project\n    id\n  }\n}\n\nfragment NofollowedPagesTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countNofollowTypesNofollowedPages(url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {\n          type\n          count\n        }\n        nofollowedPages(offset: 0, limit: 20, url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}, nofollowTypeFilters: []) {\n          count\n          edges {\n            node {\n              ...NofollowedPagesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment NofollowedPagesRow_issue on NofollowedPage {\n  id\n  type\n  severity\n  url\n  source_url\n  nofollow_types\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "indexing_IndexingCategory_NofollowedPagesTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "NofollowedPagesTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "indexing_IndexingCategory_NofollowedPagesTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countNofollowTypesNofollowedPages",
                        "storageKey": "countNofollowTypesNofollowedPages(sourceUrl:{\"operator\":\"AND\",\"values\":[]},url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v4,
                          v5
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v6,
                          v7
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "nofollowedPages",
                        "storageKey": "nofollowedPages(limit:20,nofollowTypeFilters:[],offset:0,sourceUrl:{\"operator\":\"AND\",\"values\":[]},url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "nofollowTypeFilters",
                            "value": [],
                            "type": "[String]"
                          },
                          v2,
                          v4,
                          v5
                        ],
                        "concreteType": "NofollowedPageConnection",
                        "plural": false,
                        "selections": [
                          v7,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "NofollowedPageEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "NofollowedPage",
                                "plural": false,
                                "selections": [
                                  v8,
                                  v6,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "nofollow_types",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v8
                    ]
                  }
                ]
              }
            ]
          },
          v8
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd17b31b866fcda58f0c59cf6d125090a';
module.exports = node;
